import '~/axios'
import * as Vue from 'vue'
import i18n from '~/i18n'
import App from './App.vue'
import router from './router'
import store from './store'
import AuthService from 'services/AuthService'
import CommonMixin from 'mixins/CommonMixin'
import VueToast from 'vue-toast-notification'
import VueClickAway from 'vue3-click-away'
import 'vue-toast-notification/dist/theme-sugar.css'
import '~/env'
import vue3GoogleLogin from 'vue3-google-login'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import VueVideoPlayer from '@videojs-player/vue'
import VueGtag from 'vue-gtag'
import './registerServiceWorker'
import VueSocialSharing from 'vue-social-sharing'

const vue3GoogleLoginOptions = {
    clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
}

require('styles/main.scss')
const embeds = require.context('embeds')
embeds.keys().forEach(embeds)

const app = Vue.createApp(App)
    .mixin(CommonMixin)
    .use(store)
    .use(router)
    .use(i18n)
    .use(vue3GoogleLogin, vue3GoogleLoginOptions)
    .use(VueClickAway)
    .use(VueGoogleMaps, {
        load: {
            key: env('VUE_APP_GOOGLE_MAPS_KEY'),
            libraries: 'places',
        },
    })
    .use(
        VueGtag,
        {
            appName: 'Bookeraj',
            pageTrackerScreenviewEnabled: true,
            config: { id: env('VUE_APP_GOOGLE_ANALYTICS_KEY') },
        },
        router,
    )
    .use(VueToast, { position: 'top' })
    .use(VueVideoPlayer)
    .use(VueSocialSharing)

app.config.globalProperties.$auth = AuthService
app.mount('#app')
